import React, { Component } from 'react'
import './Availabilities.scss'
import moment from 'moment-timezone'
import Calendar from 'react-calendar'
import { connect } from 'react-redux'
import { requestAvailabilities, toggleAvailability, toggleAvailabilityDay } from '../../store/availabilities/actions'

class Availabilities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      selectDay: 0,
      numFives: 0,
    }
  }

  componentDidMount() {
    if (
      this.props.availabilities.length < 1 ||
      this.props.availabilities.length === undefined ||
      this.props.availabilities.length === null
    ) {
      this.props.meetingKey &&
        this.props.requestAvailabilities(this.props.meetingId)
    }
  }

  render() {
    console.log(this.props.timeZone, 'this.props.timeZone')
    const { strings } = this.props
    const weekday = strings.weekdays

    const monthNames = strings.months

    function groupByDay(days, slot) {
      const start = moment(slot.start).toDate()
      const key =
        '' +
        start.getFullYear() +
        (start.getMonth() + 1 < 10
          ? '0' + (start.getMonth() + 1)
          : start.getMonth() + 1) +
        (start.getDate() < 10 ? '0' + start.getDate() : start.getDate())
      if (!days[key]) {
        days[key] = {
          key: key,
          full: start,
          month: start.getMonth() + 1,
          day: start.getDate(),
          weekday: weekday[start.getDay() - 1],
          monthname: monthNames[start.getMonth()],
          slots: [],
        }
      }
      days[key].slots.push(slot)
      return days
    }

    const daysObj = this.props.availabilities.reduce(groupByDay, {})
    let days = Object.values(daysObj)
    days = days.sort(function compare(a, b) {
      if (a.key < b.key) return -1
      if (a.key > b.key) return 1
      return 0
    })

    if (days.length === 0) {
      return <p />
    }

    const selectedDay = days[this.state.selectDay]

    const day_one = days[5 * this.state.numFives]
    const day_two = days[1 + 5 * this.state.numFives]
    const day_three = days[2 + 5 * this.state.numFives]
    const day_four = days[3 + 5 * this.state.numFives]
    const day_five = days[4 + 5 * this.state.numFives]

    const selectedMoments = []

    for (let i = 0; i < days.length; i++) {
      for (let j = 0; j < days[i].slots.length; j++) {
        if (days[i].slots[j].selected) {
          selectedMoments.push(days[i].slots[j])
        }
      }
    }

    return (
      <div className="availabilities has-text-centered">
        <div className="partition">
          <div className="left">
            <h2>{strings.step1}</h2>
            <Calendar
              onChange={(day) => {
                for (let j = 0; j < days.length; j++) {
                  const temp = moment(days[j].slots[0].start)
                    .startOf('day')
                    .toDate()
                  if (temp.toDateString() === day.toDateString()) {
                    this.setState({
                      selectDay: j,
                    })
                    break
                  }
                }
              }}
              tileDisabled={({ date }) =>
                !days.some(
                  (day) =>
                    day.full.getDate() === date.getDate() &&
                    day.full.getMonth() === date.getMonth() &&
                    day.full.getFullYear() === date.getFullYear(),
                )
              }
              minDate={moment(days[0].slots[0].start).toDate()}
              maxDate={moment(days[days.length - 1].slots[0].start).toDate()}
              value={moment(days[this.state.selectDay].slots[0].start).toDate()}
            />
          </div>
          <div className="right">
            <h2 className="desktopOnly">
              {' '}
              {this.props.one_moment
                ? strings.step2_a_one_moment
                : strings.step2_a}{' '}
              {this.props.duration} {strings.step2_b}
            </h2>
            <h2 className="mobileOnly">
              {' '}
              {strings.step2_a + this.props.duration + strings.step2_b}
            </h2>

            <div className="days">
              {this.state.numFives !== 0 && (
                <div
                  className="arrow"
                  onClick={() => {
                    this.setState({
                      selectDay: this.state.selectDay - 1,
                      numFives: this.state.numFives - 1,
                    })
                  }}
                  role="presentation"
                >
                  ‹
                </div>
              )}
              {day_one && (
                <div
                  className={
                    this.state.selectDay === 5 * this.state.numFives
                      ? 'day selected'
                      : 'day'
                  }
                  onClick={() => {
                    this.setState({
                      selectDay: 0 + 5 * this.state.numFives,
                    })
                  }}
                  role="presentation"
                >
                  <span className="light">{day_one.weekday}</span>
                  <span className="heavy">{day_one.day}</span>
                  <span className="light">{day_one.monthname}</span>
                </div>
              )}
              {day_two && (
                <div
                  className={
                    this.state.selectDay === 1 + 5 * this.state.numFives
                      ? 'day selected'
                      : 'day'
                  }
                  onClick={() => {
                    this.setState({
                      selectDay: 1 + 5 * this.state.numFives,
                    })
                  }}
                  role="presentation"
                >
                  <span className="light">{day_two.weekday}</span>
                  <span className="heavy">{day_two.day}</span>
                  <span className="light">{day_two.monthname}</span>
                </div>
              )}
              {day_three && (
                <div
                  className={
                    this.state.selectDay === 2 + 5 * this.state.numFives
                      ? 'day selected'
                      : 'day'
                  }
                  onClick={() => {
                    this.setState({
                      selectDay: 2 + 5 * this.state.numFives,
                    })
                  }}
                  role="presentation"
                >
                  <span className="light">{day_three.weekday}</span>
                  <span className="heavy">{day_three.day}</span>
                  <span className="light">{day_three.monthname}</span>
                </div>
              )}
              {day_four && (
                <div
                  className={
                    this.state.selectDay === 3 + 5 * this.state.numFives
                      ? 'day selected'
                      : 'day'
                  }
                  onClick={() => {
                    this.setState({
                      selectDay: 3 + 5 * this.state.numFives,
                    })
                  }}
                  role="presentation"
                >
                  <span className="light">{day_four.weekday}</span>
                  <span className="heavy">{day_four.day}</span>
                  <span className="light">{day_four.monthname}</span>
                </div>
              )}
              {day_five && (
                <div
                  className={
                    this.state.selectDay === 4 + 5 * this.state.numFives
                      ? 'day selected'
                      : 'day'
                  }
                  onClick={() => {
                    this.setState({
                      selectDay: 4 + 5 * this.state.numFives,
                    })
                  }}
                  role="presentation"
                >
                  <span className="light">{day_five.weekday}</span>
                  <span className="heavy">{day_five.day}</span>
                  <span className="light">{day_five.monthname}</span>
                </div>
              )}
              {(this.state.numFives + 1) * 5 < days.length && (
                <div
                  className="arrow"
                  onClick={() => {
                    this.setState({
                      selectDay: (this.state.numFives + 1) * 5,
                      numFives: this.state.numFives + 1,
                    })
                  }}
                  role="presentation"
                >
                  ›
                </div>
              )}
            </div>
            <div className="moments">
              {this.props.one_moment && selectedMoments.length === 1 && (
                <div>
                  <p>U selecteerde: </p>
                  <div style={{ padding: '10px' }}>
                    <span>
                      <b>
                        {moment(selectedMoments[0].start)
                          .tz(this.props.timeZone)
                          .format('D')}
                      </b>{' '}
                      {moment(selectedMoments[0].start)
                        .tz(this.props.timeZone)
                        .format('MMM')}
                      <b>
                        {' - '}
                        {moment(selectedMoments[0].start)
                          .tz(this.props.timeZone)
                          .format('kk:mm')}
                      </b>
                    </span>
                  </div>
                  <button
                    className="button is-primary full-width"
                    style={{
                      backgroundColor: this.props.secondary_color,
                      margin: '5px 0px',
                    }}
                    onClick={() => {
                      this.props.onConfirm()
                    }}
                  >
                    {strings.send}
                  </button>
                  <button
                    className="button is-secondary full-width"
                    onClick={() => {
                      this.props.toggleAvailability(
                        selectedMoments[0].start,
                        selectedMoments[0].end,
                      )
                    }}
                  >
                    {strings.pick_other_moment}
                  </button>
                </div>
              )}
              {!(this.props.one_moment && selectedMoments.length === 1) &&
                selectedDay.slots
                  .filter((slot) => {
                    return !slot.selected
                  })
                  .map((slot) => {
                    return (
                      <div key={slot.start + ' ' + slot.end} className="moment">
                        <span />
                        <span className="time">
                          {moment(slot.start)
                            .tz(this.props.timeZone)
                            .format('kk:mm')}
                        </span>
                        <span
                          className="add"
                          style={{
                            backgroundColor: this.props.secondary_color,
                          }}
                          onClick={() => {
                            this.props.toggleAvailability(slot.start, slot.end)
                          }}
                          role="presentation"
                        >
                          +
                        </span>
                      </div>
                    )
                  })}
            </div>
          </div>
        </div>
        {!(this.props.one_moment && selectedMoments.length === 1) &&
          selectedMoments.length > 0 && (
          <div className="selectedMoments">
            <div className="innerSelectedMoments">
              <p>
                {this.props.one_moment
                  ? strings.selected_moment
                  : strings.selected_moments}
              </p>
              {selectedMoments.map((slot) => {
                return (
                  <div
                    key={slot.start + '' + slot.end}
                    className="selectedMoment"
                  >
                    <span>
                      <b>
                        {moment(slot.start)
                          .tz(this.props.timeZone)
                          .format('D')}
                      </b>{' '}
                      {moment(slot.start)
                        .tz(this.props.timeZone)
                        .format('MMM')}
                    </span>
                    <span>
                      <b>
                        {moment(slot.start)
                          .tz(this.props.timeZone)
                          .format('kk:mm')}
                      </b>
                    </span>
                    <span
                      className="remove"
                      onClick={() => {
                        this.props.toggleAvailability(slot.start, slot.end)
                      }}
                      role="presentation"
                    >
                        &#10005;
                    </span>
                  </div>
                )
              })}
              <p>{strings.multiple_moments}</p>
              <button
                className="button is-primary"
                style={{ backgroundColor: this.props.secondary_color }}
                onClick={() => {
                  this.props.onConfirm()
                }}
              >
                {strings.send}
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isOneOnOne: true,
    isFetching: state.availabilities.isFetching,
    availabilities:
      state.availabilities && state.availabilities.availabilities
        ? state.availabilities.availabilities.sort((a, b) => {
          return a.start > b.start ? 1 : -1
        })
        : [],
    timeZone: state.general.timeZone,
    primary_color: state.meetingPage.colors
      ? state.meetingPage.colors.primary
      : '10365D',
    secondary_color: state.meetingPage.colors
      ? state.meetingPage.colors.secondary
      : '10365D',
    strings: state.languages.strings.link.availabilities,
    one_moment: state.meetingPage.one_moment,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleAvailability: (start, end) => {
      dispatch(toggleAvailability(start, end))
    },
    toggleAvailabilityDay: (utcMonth, utcDay) => {
      dispatch(toggleAvailabilityDay(utcMonth, utcDay))
    },
    requestAvailabilities: (meeting_id) => {
      dispatch(requestAvailabilities(meeting_id))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Availabilities)
